module.exports = __webpack_public_path__ + "img/049.44abf59b.png";